import React, { useState, useEffect } from 'react';
import './style.css';
import './general.css';
import Home from './Components/Home';
import Cards from './Components/Cards';
import Data from './info'
import Search from './Components/Search';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'




function App() {

  const [UsersInfo, SetusersInfo] = useState([])

  useEffect(() => {
    console.log("render")

  })

  useEffect(() => {

    const info = window.localStorage.getItem("Coligo")
    if (info) {
      SetusersInfo(JSON.parse(info));


    }


  }, [])
  useEffect(() => {
    window.localStorage.setItem("Coligo", JSON.stringify(UsersInfo))

  })



  function removeUser(id) {
    SetusersInfo(prev => {
      let NewUsers;
      return NewUsers = prev.filter((user) => {
        return user.id !== id
      })

    })

  }


  return (

    <Router basename='/Coligo/'>
      <Routes>
        <Route exact path='/' element={<Home></Home>}>

        </Route>
        <Route exact path='/SearchFriend' element={<Search FriendsList={UsersInfo} AddFriend={SetusersInfo}></Search>}>

        </Route>
        <Route exact path='/FriendsList' element={<Cards remove={removeUser} UsersInfo={UsersInfo} ></Cards>}></Route>

      </Routes>
    </Router>
  )

}

export default App;
